import { render, staticRenderFns } from "./StickyHeaderColumnTable.vue?vue&type=template&id=3b817dd2"
import script from "./StickyHeaderColumnTable.vue?vue&type=script&lang=js"
export * from "./StickyHeaderColumnTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports